import { Component, Inject, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RecommenderService } from '@fuse/services/recommender/recommender.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyService } from '@fuse/services/company.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as moment from 'moment';

@Component({
    selector: 'recommendation-form-dialog',
    templateUrl: './recommender-form.component.html',
    styleUrls: ['./recommender-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class RecommenderFormDialogComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any>;
    action: string;
    recommender: any;
    requestTypes: any;
    company: any;
    recommenderForm: FormGroup;
    dialogTitle: string;
    cities: any[];
    enabledCities: any[];
    lang = 'sr';
    selectedType: any;
    maxDate; 

    /**
     * Constructor
     *
     * @param {MatDialogRef<RecommenderFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<RecommenderFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _recommenderService: RecommenderService,
        private _formBuilder: FormBuilder,
        private _matSnackBar: MatSnackBar,
        private _companyService: CompanyService,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        this._unsubscribeAll = new Subject();

        // Set the defaults
        this.action = _data.action;
        this.dialogTitle = 'New recommendation';
        this.recommenderForm = this.createRecommendationForm();

        this.maxDate = moment();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '25');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    // convenience getter for easy access to form fields
    get f(): any { return this.recommenderForm.controls; }

    /**
     * Create city form
     *
     * @returns {FormGroup}
     */
    createRecommendationForm(): FormGroup {
        return this._formBuilder.group({
            first_name: [],
            last_name: [],
            email: [],
            phone_number: [],
            date_of_birth: []
        });
    }

    checkServerError(fieldName): any {
        return this.recommenderForm.get(fieldName).errors ? this.recommenderForm.get(fieldName).errors.serverError ?
            this.recommenderForm.get(fieldName).errors.serverError : this._translate.instant('This field is required!') : false;
    }

    createRecommendation(recommenderForm): void {
        const data = recommenderForm.getRawValue();
        if (!data.date_of_birth) {
            data.date_of_birth = null;
        } else {
            if (moment.isMoment(data.date_of_birth)) {
                data.date_of_birth = data.date_of_birth.format('YYYY-MM-DD');
            }
        }
        this._recommenderService.createRecommendation(data, this.company.id, this.lang)
            .then(x => {

                this.matDialogRef.close(['save', recommenderForm]);

                // Show the success message
                this._matSnackBar.open(this._translate.instant('Recommendation for') + ' ' + 
                recommenderForm.getRawValue().first_name + ' ' + recommenderForm.getRawValue().last_name + this._translate.instant(' created successfully.'), '', {
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 2000
                });
            })
            .catch(err => Promise.reject(err))
            .then(x => { }, err => {
                const validationErrors = err.error;
                for (const key of Object.keys(validationErrors)) {
                    const formControl = this.recommenderForm.get(key);
                    if (formControl) {
                        formControl.setErrors({
                            serverError: validationErrors[key]
                        });
                    }
                }
            });
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
        this._companyService.getActiveCompany()
            .then(response => {
                this.company = response;
            })
            .catch(err => Promise.reject(err))
            .then(() => {
                this._recommenderService.getAllRequestTypes(this.company.id)
                .then(response => {
                    this.requestTypes = response.data;
                    console.log(this.requestTypes);
                });
            }, err => {
            }); 
            
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });

        this.getTranslations();

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
